var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotPatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 27,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(-4.024 -3.394)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(3.476 -3.394)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(10.976 -3.394)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(18.476 -3.394)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(25.976 -3.394)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(33.476 -3.394)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(-4.024 11.605)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(3.476 11.605)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(10.976 11.605)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(18.476 11.605)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(25.976 11.605)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(33.476 11.605)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(-.244 4.106)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(7.256 4.106)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(14.756 4.106)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(22.256 4.106)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(29.756 4.106)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(37.256 4.106)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(-.244 19.105)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(7.256 19.105)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(14.756 19.105)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(22.256 19.105)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(29.756 19.105)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.513,
    cy: 5.519,
    r: 1.489,
    transform: "translate(37.256 19.105)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotPatch);
export default __webpack_public_path__ + "static/media/DotPatch.d126dee55575e7054105d5c38d34be67.svg";
export { ForwardRef as ReactComponent };